module.exports = __webpack_public_path__ + "static/img/yzj.58623bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/yzj.png
// module id = 56AW
// module chunks = 1